export function CashOutFormatter(data) {
  const agrupadas = {};

  const mapFormaPago = {
    'TDD': 'TDD',
    'TDC': 'TDC',
    'DEBITO': 'TDD',
    'CRÉDITO': 'TDC',
    'CREDITO': 'TDC',
    'EFECTIVO': 'EFECTIVO',
    'TRANSFER': 'TRANS',
    'TRANSFERENCIA': 'TRANS',
    'TRANS': 'TRANS',
  };

  data.forEach(item => {
    const folio = item.FOLIO;
    const rawTipo = (item.CODE || item.FORMA_PAGO || '').toUpperCase();
    const tipo = mapFormaPago[rawTipo] || '';
    const monto = parseFloat(item.MONTO || 0) || 0;

    if (!agrupadas[folio]) {
      agrupadas[folio] = {
        FOLIO: folio,
        TDD: 0,
        TDC: 0,
        EFECTIVO: 0,
        TRANS: 0,
      };
    }

    if (tipo && agrupadas[folio].hasOwnProperty(tipo)) {
      agrupadas[folio][tipo] += monto;
    }
  });

  return Object.values(agrupadas);
}
